import BigNumber from "bignumber.js";

interface Decimal128 {
  $numberDecimal: string;
}

function isDecimal128(value: unknown): value is Decimal128 {
  return (
    typeof value === "object" &&
    value !== null &&
    "$numberDecimal" in value &&
    typeof (value as Decimal128).$numberDecimal === "string"
  );
}

export const convertDecimal128 = (value: unknown): string | number => {
  if (isDecimal128(value)) {
    const bigNumberValue = new BigNumber(value.$numberDecimal);
    return bigNumberValue.toFixed(); // This ensures no scientific notation, returning a string
  }
  if (value === null || value === undefined) return 0;
  if (value === "") return 0;
  if (typeof value === "string" || typeof value === "number") return value;
  return 0;
};

export const parseAmount = (value: unknown): number => {
  if (value === null || value === undefined || value === "") return 0;

  if (value === 0) return 0;

  if (typeof value === "object" && value !== null) {
    if (isDecimal128(value)) {
      const parsed = parseFloat(value.$numberDecimal);
      return Number.isNaN(parsed) ? 0 : parsed;
    }
    return 0;
  }

  if (typeof value === "string") {
    let cleaned = value
      .trim()
      .replace(/^[R$ZARUSD\s]+/i, "")
      .replace(/\s/g, "")
      .replace(/,/g, ".");

    const periodCount = (cleaned.match(/\./g) || []).length;
    if (periodCount > 1) {
      const lastPeriodIndex = cleaned.lastIndexOf(".");
      cleaned =
        cleaned.substring(0, lastPeriodIndex).replace(/\./g, "") +
        cleaned.substring(lastPeriodIndex);
    }

    const parsed = parseFloat(cleaned);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  if (typeof value === "number") {
    return Number.isNaN(value) ? 0 : value;
  }

  return 0;
};
